module.exports = __webpack_public_path__ + "img/Monaco.c7b9d029.png";